"use client";

import type { FormVariant } from "@homeinstead/analytics";

import { buildLeadFormStepEvent, track } from "@homeinstead/analytics";
import { EventName } from "@homeinstead/shared";

/**
 * Fires the unified "Lead Form Step" Segment event for legacy (non-LFB) lead
 * forms. Call this immediately alongside the existing `tracked_click` event
 * as part of the dual-fire transition strategy.
 *
 * step_name values for legacy steps:
 *   "recipient"  — care-recipient selection
 *   "care-type"  — care services / care option selection
 *   "urgency"    — urgency selection
 *   "zipcode"    — zipcode/location-only step (v4)
 *   "office"     — office/location selection step (national v1)
 *   "name"       — first/last name step (v5)
 *
 * page_zone for legacy forms defaults to "ppc" but may differ per placement.
 */
function trackLegacyLeadFormStep({
  stepName,
  userSelection,
  formVariant,
  pageZone = "ppc",
}: {
  stepName: string;
  userSelection?: Record<string, string | string[]>;
  formVariant: FormVariant;
  pageZone?: string;
}) {
  track(
    EventName.LEAD_FORM_STEP,
    buildLeadFormStepEvent({
      formVariant,
      isCorporate: false,
      pageZone,
      stepName,
      userSelection,
    }),
  );
}

export { trackLegacyLeadFormStep };
